import { GetLicenseTypesDocument } from '@/api/queries';
import SelectFromQuery from '../SelectFromQuery';

const SelectLicenseType = (props) => (
  <SelectFromQuery
    cache="LicenseType"
    placeholder="Select Type"
    query={GetLicenseTypesDocument}
    selector={(data) =>
      (data?.getFilters?.filters?.licenseType || []).map((opt) => ({
        label: opt.displayName,
        value: opt.id,
      }))
    }
    {...props}
  />
);

export default SelectLicenseType;
